import { createContext, useContext } from 'react';

/**
 * Seated (seats.io) events have **no shared-capacity pools** (the Pools accordion is gated out for them), so
 * any analytics help/tooltip copy that explains pools is confusing on a seated show. This is decided ONCE at
 * the analytics page root (`PunchupAnalytics`, from `event.seatsEventKey`) and read wherever copy branches —
 * a single page-wide check, rather than each section re-deriving it. Default `false` so a section rendered
 * without the provider (e.g. in isolation in a test) reads as non-seated.
 */
const AnalyticsSeatedContext = createContext(false);

export const AnalyticsSeatedProvider = AnalyticsSeatedContext.Provider;

/** True when the analytics page is showing a seated (seats.io) event — suppress pool copy. */
export const useIsSeatedEvent = (): boolean => useContext(AnalyticsSeatedContext);
